export const RoutesPath = {
    PUBLIC: {
        BGC_VOTING: "bgc-voting",
        LOGIN: "login",
        REGISTER: "register",
        FORGOT_USERNAME: "forgot-username",
        FORGOT_PASSWORD: "forgot-password",
        RESET_PASSWORD: "reset-password",
        UAEPASS_LOGIN: "uaepass-login",
        LOGIN_CALLBACK: "login-callback",
        LOGOUT_CALLBACK: "logout-callback",
        MEDIATION_CASE: "mediation-case",
        MEDIATION_CASE_DETAIL: "mediation-case-detail",
        BGC_QUESTIONARIES: "bgc-questionaries",
    },
    DASHBOARD: 'dashboard',
    SERVICES_LIST: 'services',
    SERVICE_DETAIL: 'service-detail',
    SERVICE: 'service',
    BUSINESS_GROUPS_COUNCILS: 'business-group-councils',
    BUSINESS_GROUP: 'business-group',
    ESTABLISH_BGC_FORM: 'establish-bgc',
    RENEW_BGC_FORM: 'renew-bgc',
    BGC_APPLICATION_VIEW: 'bgc-application-view',
    ACCOUNT_MANAGEMENT: "account-management",
    APPLICATIONS: "applications",
    PAYMENTS: "payments",
    STATEMENTS: "statements",
    DOCUMENTS: "documents",
    VENUES: 'venues',
    ATA_CARNET: 'ata-carnet',
    NOTIFICATIONS: 'notifications',
    PROFILE: 'profile',
    CONTACT_US: 'contact-us',
    FAQ: 'faq',
    DIRECTORY: 'directory',
    SERVICE_MANUALS: 'service-manuals',
    ACCESS_REQUEST_DETAIL: 'account-management/access-request-detail',
    USER_DETAIL: 'account-management/user-detail',
    UPDATE_USER: 'account-management/update-user',
    ADD_USER: 'account-management/add-user',
    ADD_MORE_BUSINESS: 'add-more-business',
    MEMBERSHIP: {
        REGISTRATION: 'membership-registration',
        DETAIL: 'membership-detail',
        AMENDMENT: 'membership-amendment',
        RENEW: 'membership-renewal',
        CANCELLATION: 'membership-cancellation',
        MANAGE_SIGNATORIES: 'membership-manage-signatories',
        COMPLETE_COMPANY_INFORMATION: 'company-information'
    },
    SUCCESS_PAGE: 'success',
    INFORMATION_SERVICE: 'information-service',
    PAYMENT: 'payment',
    PAYMENT_CONFIRMATION: 'payment-confirmation',

    ATTESTATION: {
        AUTHENTICATE: 'attestation-authenticate-document',
        CERTIFY: 'attestation-certify-document',
        VERIFY_SIGNATURE: 'attestation-verify-signature',
    },
    COO: {
        ISSUE: 'coo',
        AMENDMENT: 'coo-amendment',
        PERSONAL: 'coo-personal-effect',
        GSP_CERTIFICATE: 'issue-gsp-certificate',
        BULK_UPLOAD: 'coo-bulk-upload',
    },
    MEDIATION: 'mediation',
    ATA: {
        CARNET: 'ata-carnet-registration',
        AMENDMENT: 'ata-carnet-amendment',
        PREVIEW: 'ata-carnet-preview',
        TERMS: 'ata-carnet-terms-conditions',
        REFUND: 'ata-carnet-refund',
        SUBSTITUTE: 'ata-carnet-substitute',
        REPLACE: 'ata-carnet-replace',
        CANCEL: 'ata-carnet-cancel',
        NOC_LETTER: 'ata-carnet-noc-letter',
    },
    VENUE: {
        VENUE_LIST: 'venues',
        BOOKING_DETAIL: 'venue-booking-detail',
        DETAILS: 'venue-details',
    },
    SUSTAINABILITY: "sustainabilty",
    PLATINUM_MEMBERSHIP_BENEFITS: "platinum-membership-benefits",
    MYSTERY_SHOPPER: 'mystery-shopper',
    MRM_AWARDS: 'mrm-award',
    MRM_TRAINING_WORKSHOP: 'mrm-training-workshop',
    COMPANY_INFORMATION: 'company-information',
    STATICS: 'statics',
    CHAMBER_ENTREPRENEURS: "chamber-entrepreneur"
};
